import { Container, Point, Sprite, Text, TextStyle, Texture } from "pixi.js";
import { GameFont } from "../../../common/GameFont";
import { BuildingRankUpResourcePackage } from "../resources/BuildingRankUpResourcePackage";
import { HBox } from "../../../common/components/ui/HBox";
import { DropShadowFilter } from "pixi-filters";
import { ShineRenterAnimation } from "./ShineRenterAnimation";
import { ICanvasScaler } from "by/gamefactory/canvas/ICanvasScaler";
import { Avatar } from "../../../common/components/Avatar";
import { UserProfileResourcePackage } from "../../userprofile/resources/UserProfileResourcePackage";
import { IPlayerModel } from "../../../common/models/IPlayerModel";
import { StringFormatExtention } from "by/gamefactory/extensions/StringFormatExtention";

export class BuildingRankUpLandlordRewardComponent extends Container {
    private static readonly YOUR_REWARD_TEXT = 'YOUR REWARD';

    private yourRewardText: Text;
    private avatar: Avatar;
    private rewardCount: Text;
    private rewardIcon: Sprite;
    private rewardBox: HBox;
    private rewardGoldFilter: DropShadowFilter;
    private shineRenterAnimation: ShineRenterAnimation;

    public constructor(
        rankUpResources: BuildingRankUpResourcePackage,
        userProfileResources: UserProfileResourcePackage,
        avatarTexture: Texture,
        rewardCount: number,
        playerModel: IPlayerModel,
        canvasScaler: ICanvasScaler
    ) {
        super();
        this.rewardGoldFilter = new DropShadowFilter({
            offset: new Point(0, 0),
            blur: 30,
            color: 0xFFC700,
            quality: 4.5,
            alpha: 1,
            pixelSize: 0.6
        });
        this.yourRewardText = new Text(BuildingRankUpLandlordRewardComponent.YOUR_REWARD_TEXT, new YourRewardTextStyle());
        this.avatar = new Avatar(userProfileResources, avatarTexture);
        this.avatar.avatarSize = new Point(190, 190);
        this.avatar.glow = playerModel.isAuthorized;
        this.avatar.enabled = false;
        this.rewardBox = new HBox(25);
        this.rewardCount = new Text(StringFormatExtention.formatWithComma(rewardCount), new RewardTextStyle());
        this.rewardIcon = new Sprite(rankUpResources.assets_views_building_rank_up_coin_png);
        this.rewardIcon.width = this.rewardIcon.height = 99;
        this.rewardBox.filters = [this.rewardGoldFilter];
        this.rewardBox.addChild(this.rewardCount, this.rewardIcon);
        this.shineRenterAnimation = new ShineRenterAnimation(canvasScaler);
        this.shineRenterAnimation.visible = playerModel.isAuthorized;
        this.addChild(this.yourRewardText, this.avatar, this.rewardBox, this.shineRenterAnimation);
        this.layout();
    }

    public async playAvatarAnimation(): Promise<void> {
        await this.shineRenterAnimation.play();
    }

    private layout(): void {
        this.yourRewardText.position.set(6, -4);
        this.avatar.position.set(48, 67);
        this.rewardCount.position.y = -4;
        this.rewardIcon.position.y = -18;
        this.rewardBox.position.set(this.avatar.position.x + this.avatar.width * 0.5 - this.rewardBox.width * 0.5, 313);
        this.shineRenterAnimation.scale.set(2.32, 0.5);
        this.shineRenterAnimation.position.set(this.avatar.x + this.avatar.width * 0.5 - 3, this.avatar.y + this.avatar.height * 0.5 - 4);
    }

    public hide(): void {
        this.shineRenterAnimation.visible = false;
    }
}

class YourRewardTextStyle extends TextStyle {
    public constructor() {
        super({
            fontFamily: GameFont.DEFAULT_FONT,
            fontSize: 64,
            fill: '#FFFFFF'
        })
    }
}

class RewardTextStyle extends YourRewardTextStyle {
    public constructor() {
        super();
        this.fontSize = 89;
    }
}